var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4999,
    cy: 10.1552,
    r: 5.15517,
    stroke: "#FE214F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.4824H20C23.866 19.4824 27 22.6164 27 26.4824V28.241C27 29.8979 25.6569 31.241 24 31.241H11C9.34315 31.241 8 29.8979 8 28.241V26.4824C8 22.6164 11.134 19.4824 15 19.4824Z",
    stroke: "#FE214F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMapIcon);
export default __webpack_public_path__ + "static/media/user_map_icon.59310e341f58d11e23f9566df6e5ad22.svg";
export { ForwardRef as ReactComponent };